import { useTranslation } from "react-i18next";
import { Promocodes as PromocodesFeature } from "@/partner/features/promocodes";
import { Meta } from "@/shared/components";

export function PromocodesPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("promocodes.pageTitle")} pageType="Partner" />
      <PromocodesFeature />
    </>
  );
}
